import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50 whitespace-nowrap">
                黄瓜视频
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/50 max-w-xs">
              无需下载安装，直接在浏览器打开即可使用的在线视频平台。海量视频内容免费观看，随时随地享受优质视频体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快捷导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/dianying" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  视频分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">视频分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系方式</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/50">
                <i className="ri-mail-line text-base"></i>
                <span>contact@huanggua-video.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/50">
                <i className="ri-customer-service-2-line text-base"></i>
                <span>在线客服 7×24小时</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="w-full px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 黄瓜视频网页版. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/60 transition-colors whitespace-nowrap">Cookie设置</a>
          </div>
        </div>
      </div>
    </footer>
  );
}